import axiosInstance from "@/lib/axios";

export const paymentService = {
  getPayments: async ({ page = 1, status = 'all', startDate = null, endDate = null }) => {
    let url = `/api/v1/admin/payments?page=${page}`;
    
    if (status && status !== 'all') {
      url += `&status=${status}`;
    }
    
    if (startDate) {
      url += `&start_date=${startDate}`;
    }
    
    if (endDate) {
      url += `&end_date=${endDate}`;
    }
    
    const response = await axiosInstance.get(url);
    return response.data;
  },
  
  getPaymentDetails: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/payments/${id}`);
    return response.data;
  },
  
  getStatistics: async ({ status = 'all', startDate = null, endDate = null }) => {
    let url = `/api/v1/admin/payments/statistics`;
    let params = new URLSearchParams();
    
    if (status && status !== 'all') {
      params.append('status', status);
    }
    
    if (startDate) {
      params.append('start_date', startDate);
    }
    
    if (endDate) {
      params.append('end_date', endDate);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    const response = await axiosInstance.get(url);
    return response.data;
  },
  
  exportPayments: async ({ status = 'all', startDate = null, endDate = null }) => {
    let url = `/api/v1/admin/payments/export`;
    let params = new URLSearchParams();
    
    if (status && status !== 'all') {
      params.append('status', status);
    }
    
    if (startDate) {
      params.append('start_date', startDate);
    }
    
    if (endDate) {
      params.append('end_date', endDate);
    }
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    // Pour un téléchargement, on utilise window.location
    window.location.href = url;
  }
};

export default paymentService;